import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "user-list-table-header-cell-container",
    style: _normalizeStyle(_ctx.styles)
  }, _toDisplayString(_ctx.text), 5))
}